import { SettlementStaysDTO } from 'types';
import { commonTexts, jsonObjectsTexts } from 'consts/text';
import { EMPTY_VALUE_LABEL } from 'consts/labels/common';
import { parseStringIntoDayjsTime } from 'utils/parsers/dateTime/parseStringIntoDayjsTime';
import { settlementConfigurationLabels } from 'consts/settlement/settlementConfigurationLabels';
import { methodOfCalcTheFeeLabels } from 'consts/settlementStays/methodOfCalcTheFeeLabels';
import { getFormattedPrice } from 'utils/getFormattedPrice';

export const parseSettlementStaysDTOIntoJsonObject: (
    settlementStaysDTO: SettlementStaysDTO,
) => object = (settlementStaysDTO) => {
    const {
        settlementType,
        paymentType,
        freeHours,
        freeHoursAmount,
        freeHoursTimeFrame,
        freePeriodStart,
        freePeriodEnd,
        price,
    } = settlementStaysDTO;

    const settlementTypeLabel = settlementConfigurationLabels[settlementType];
    const paymentTypeLabel = methodOfCalcTheFeeLabels[paymentType];
    const formattedfreePeriodStart = freePeriodStart
        ? parseStringIntoDayjsTime(freePeriodStart)
        : EMPTY_VALUE_LABEL;
    const formattedfreePeriodEnd = freePeriodEnd
        ? parseStringIntoDayjsTime(freePeriodEnd)
        : EMPTY_VALUE_LABEL;
    const formattedPrice = price ? getFormattedPrice(price) : EMPTY_VALUE_LABEL;

    return {
        [jsonObjectsTexts.settlementStaysDTO.fields.settlementType]: settlementTypeLabel,
        [jsonObjectsTexts.settlementStaysDTO.fields.paymentType]: paymentTypeLabel,
        [jsonObjectsTexts.settlementStaysDTO.fields.freeHours]: freeHours
            ? commonTexts.dataLabels.yes
            : commonTexts.dataLabels.no,
        [jsonObjectsTexts.settlementStaysDTO.fields.freeHoursAmount]:
            freeHoursAmount || EMPTY_VALUE_LABEL,
        [jsonObjectsTexts.settlementStaysDTO.fields.freeHoursTimeFrame]: freeHoursTimeFrame
            ? commonTexts.dataLabels.yes
            : commonTexts.dataLabels.no,
        [jsonObjectsTexts.settlementStaysDTO.fields.freePeriodStart]: formattedfreePeriodStart,
        [jsonObjectsTexts.settlementStaysDTO.fields.freePeriodEnd]: formattedfreePeriodEnd,
        [jsonObjectsTexts.settlementStaysDTO.fields.price]: formattedPrice,
    };
};
